/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\Header\HeaderMenu\HeaderMenu.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Thursday August 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday August 17th 2023 11:33:01 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineMenu, AiOutlinePoweroff, AiOutlineUser } from "react-icons/ai";
import { useLang } from "Router/LangueProvider";
import { useAuth } from "Router/AuthProvider";
import IconButton from "@mui/material/IconButton";
import Styles from "Content/Header/HeaderMenu/HeaderMenu.module.css";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { FaCar, FaBookReader } from "react-icons/fa";
import { IoHomeOutline } from "react-icons/io5";
import HrStyled from "Theme/Component/HrStyled";

function HeaderMenu() {
    const {translator} = useLang();
    const navigate = useNavigate();
    const { logout, isConnected } = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (redirectPath: string) => {
        if (typeof(redirectPath) === "string" && redirectPath !== "")
            navigate(redirectPath);
        setAnchorEl(null);
    };

    const menuItems = [
        {
            icon: <IoHomeOutline size={"1.5rem"} />,
            text: translator.decode("navbar.home"),
            nav: RouterPathResolver.pathEntryPoint.path,
        },
        {
            icon: <FaCar size={"1.5rem"} />,
            text: translator.decode("navbar.carList"),
            nav: RouterPathResolver.routeCars.path,
        },
        {
            icon: <FaBookReader size={"1.5rem"} />,
            text: translator.decode("navbar.about"),
            nav: RouterPathResolver.routeAbout.path,
        }
    ];

    return (
        <div>
        <IconButton
            onClick={handleClick} id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            aria-label="Menu">
                <AiOutlineMenu size={"2rem"}/>
        </IconButton>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{'aria-labelledby': 'basic-button',}}
        >
            <div className={`${Styles.extranav}`}>
                {
                    menuItems.map((x) => <Link className={`${Styles.link}`} to={x.nav} key={Math.random()}>
                        <MenuItem onClick={() => handleClose("")}>
                                {x.icon}
                                <span className="ms-2 text-capitalize">
                                    {x.text}
                                </span>
                            </MenuItem>
                        </Link>)
                }
                <HrStyled margin={"0.5rem"} />
            </div>
            {
                isConnected ?
                    <div>
                        <Link className={`${Styles.link}`} to={RouterPathResolver.routeProfil.path}>
                            <MenuItem onClick={() => handleClose("")}>
                                    <AiOutlineUser size={"1.5rem"} />
                                    <span className="ms-2">
                                        {translator.decode("dynamic.profile")}
                                    </span>
                            </MenuItem>
                        </Link>
                        <HrStyled margin={"0.5rem"} />
                        <MenuItem onClick={() => {logout()}}>
                            <div className="d-flex align-items-center">
                                <p className="m-0 me-1"> {translator.decode("login.logout")} </p>
                                <AiOutlinePoweroff fill="red"/>
                            </div>
                        </MenuItem>
                    </div>
                    : null
            }
        </Menu>
    </div>
    )
}

export default HeaderMenu;
